import { EntityVm } from 'api/core/entity.vm';
import { IsString } from 'class-validator';

export class SupplierVm extends EntityVm {
  @IsString()
  name: string;
}
